import {
  BrowserJsPlumbInstance,
  BrowserJsPlumbDefaults,
  newInstance,
} from '@jsplumb/browser-ui';
import { Connection } from '@jsplumb/core';

class JspSingleton {
  /**
   * @type {BrowserJsPlumbInstance}
   * @private
   */
  #jspInstance = null;

  /**
   * @type {Connection}
   * @private
   */
  #jspDummyConnection = null;

  /**
   * Creates a new jsPlumb Instance
   * @param {BrowserJsPlumbDefaults} defaults
   */
  createInstance(defaults) {
    console.log('Creating new jspInstance', defaults);
    this.#jspInstance = newInstance(defaults);
  }

  /**
   * @returns {BrowserJsPlumbInstance}
   */
  get instance() {
    return this.#jspInstance;
  }

  /**
   *
   * @param {string} id The connection ID
   * @returns {(Connection|null)}
   */
  getConnection(id) {
    return (
      this.#jspInstance.connections.find(connection => connection.id === id) ||
      null
    );
  }

  /**
   * Creates a Dummy Connection for a dummy element.
   * Stored in instance so it doesn't get proxied.
   * @param {import('@jsplumb/core').ConnectParams} options
   */
  createDummyConnection(options) {
    this.#jspDummyConnection = this.#jspInstance.connect(options);
  }

  /**
   * Deletes the Dummy Connection.
   * @param {import('@jsplumb/core').ConnectParams} options
   */
  deleteDummyConnection() {
    this.#jspInstance.deleteConnection(this.#jspDummyConnection);
    this.#jspDummyConnection = null;
  }
}

const jspSingletonInstance = Object.freeze(new JspSingleton());

export default jspSingletonInstance;
